<template>
  <CardPrimary
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <HeaderMediumPrimary
      :truncate="true"
      :style="style.header"
    >
      {{ survey.name }}
    </HeaderMediumPrimary>
    <div :style="style.center">
      <div
        v-if="survey.completedSurveyCount > 0"
        :style="style.userImages"
      >
        <UserImagePrimary
          v-for="(tenantUser, index) in survey.completedTenantUsersSubset"
          :key="index"
          :disableLink="true"
          :size="userImageSize"
          :tenantUser="tenantUser"
        />
      </div>
      <TextSmallPrimary>
        {{ completedSurveyCountText }}
      </TextSmallPrimary>
    </div>
    <ButtonPrimary @click="$emit('select', survey)">
      Select
    </ButtonPrimary>
  </CardPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardPrimary from '@modules/v2/card/card-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import TextSmallPrimary from '@modules/v2/text/text-small-primary'
  import UserImagePrimary from '@modules/v2/image/user-image-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'CardSurvey',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      CardPrimary,
      HeaderMediumPrimary,
      TextSmallPrimary,
      UserImagePrimary,
    },
    props: {
      survey: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        userImageSize: Layout.space.lg,
        style: {
          card: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '176px',
            justifyContent: 'space-between',
            padding: Layout.space.md,
            textAlign: 'center',
            width: '100%',
          },
          center: {
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            width: '100%',
          },
          header: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          userImages: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-end',
            margin: `0 ${Layout.space.sm} 0 0`,
          }
        },
      };
    },
    computed: {
      completedSurveyCountText: function () {
        const count = this.survey.completedSurveyCount;
        return `${count} response${count > 1 ? 's' : ''}`
      },
      completedTenantUserImages: function () {
        return this.survey.completedTenantUsersSubset.reduce(
          (result, elem) => {
            result.push(elem.user.image);
            return result;
          }, []
        );
      },
    },
  };
</script>
